import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCollectionDetails } from "../../hooks/Collectionhook";
import { avatar, DefaultProfile } from "../../assets/img";
import { listNFTs } from "../../hooks/NFTHook";
import { contractAddress } from "../../config/BackendUrl";
import DynamicNFTCard from "../cards/DynamicCard";
import Pagination from "../Pagination";
import CardPlaceholder from "../cards/NFTCardPlaceholder";
import { handleApiError, retryApiCall } from "../../utils/apiUtils";

function CollcetionLiveCard(props) {
  const [nfts, setNfts] = useState([]);
  const [check, setCheck] = useState(false);
  const collectionAddress = props.contractAddress;
  const userIds = localStorage.getItem("userId");
  const userId = localStorage.getItem("userId");
  const [isPagination, setIsPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [hasMore, setHasMore] = useState(true); // Flag for infinite scroll
  const location = useLocation();
  const userWalletAddress = localStorage.getItem("WalletAddress");
  const [limit, setLimit] = useState(8);

  useEffect(() => {
    fetchNFTs();
  }, [currentPage, props.filter]);

  const fetchNFTs = async () => {
    try {
      let Params;
      if (props.filter === null) {
        Params = {
          page: currentPage + 1,
          limit: 8,
          contractAddress: collectionAddress,
          inAuction: true,
          listed: true,
        };
      }
      if (props.filter === "createdAt") {
        Params = {
          page: currentPage + 1,
          limit: 8,
          sortBy: "createdAt",
          contractAddress: collectionAddress,
          inAuction: true,
          listed: true,
        };
      }
      if (props.filter !== null && props.filter !== "createdAt") {
        Params = {
          page: currentPage + 1,
          limit: 8,
          contractAddress: collectionAddress,
          inAuction: true,
          listed: true,
          category: props.filter,
        };
      } else {
        Params = {
          page: currentPage + 1,
          limit: 8,
          sortBy: "createdAt",
          contractAddress: collectionAddress,
          inAuction: true,
          listed: true,
        };
      }

      const allNFTs = await retryApiCall(() => listNFTs(Params), 3, 1000);

      if (allNFTs.success) {
        const NFT = allNFTs.data;
        const AddIsLikeFlag = NFT.map((item) => {
          const isLike = item.likes.some((like) => like.userId === userIds);
          return { ...item, isLike };
        });

        setNfts(AddIsLikeFlag);
        setPageCount(allNFTs.totalPages);
        setIsPagination(allNFTs.totalPages > 1);
        setHasMore(allNFTs.total > 0);
      } else {
        throw new Error("Failed to fetch NFTs");
      }
    } catch (error) {
      handleApiError(error, "Failed to load NFTs");
      setHasMore(false);
    }
  };

  useEffect(() => {
    if (location.state === true) {
      if (collectionAddress === contractAddress) {
        fetchNFTs();
      } else {
        getCollectionDetails(collectionAddress).then((data) => {
          if (data.status === 201) {
            fetchNFTs(data.data.ownerAddress);
          }
        });
      }
    }
  }, [location.state]);

  const handlePageChange = (selectedItem) => {
    setNfts([]);
    setCurrentPage(selectedItem.selected);
  };

  return (
    <div>
      <div className="row">
        {nfts.length !== 0 ? (
          nfts.map((val, i) => (
            <div key={i} className="col-lg-3 col-md-4 col-sm-6">
              <DynamicNFTCard
                NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`}
                contractAddress={val.contractAddress}
                currentOwnerPic={val?.currentOwner?.userId?.profilePicture}
                currentOwnerName={val?.currentOwner?.userId?.name}
                currentOwnerLink={
                  val?.currentOwner?.walletAddress !== userWalletAddress
                    ? `/otherProfile/${val?.currentOwner?.walletAddress}`
                    : "/profile"
                }
                mediaUrl={val.imageUri} // Can be an image or video URL
                assetType={val.assetType} // Pass `true` for video or `false` for image
                title={val.title}
                price={val.price}
                likes={val.totalLikes}
                isLiked={val.isLike}
                tokenId={val.tokenId}
                isListed={val.listed}
                nftId={val._id}
                isCollection={false}
              />
            </div>
          ))
        ) : hasMore ? (
          [...Array(limit)].map((_, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <CardPlaceholder />
            </div>
          ))
        ) : (
          <h3>No NFT Available</h3>
        )}
      </div>
      {isPagination && (
        <Pagination
          pageCount={pageCount}
          onPageChange={handlePageChange}
          currentPage={currentPage}
        />
      )}
    </div>
  );
}

export default CollcetionLiveCard;
